import { render } from "./OptionsSbi.vue?vue&type=template&id=1e3f6aa4"
import script from "./OptionsSbi.vue?vue&type=script&lang=js"
export * from "./OptionsSbi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__